var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"lg":"12","md":"12","cols":"12","sm":"12"}},[_c('StockArray',{attrs:{"dist-points":_vm.distPoints}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }